export enum OrdersApisActionTypes {
    ORDERS_API_RESPONSE_SUCCESS = 'ORDERS_API_RESPONSE_SUCCESS',
    ORDERS_API_RESPONSE_ERROR = 'ORDERS_API_RESPONSE_ERROR',
    GET_ORDERS_APIS_DATA = 'GET_ORDERS_API_DATA'
}
